import React, { useState } from "react";
import "../../../static/css/App.css";
import OrderTable from "../orderTable";
const ShippedOrders = () => {
  return (
    <>
      <OrderTable status={5} isActive="shipped" />
    </>
  );
};


export default ShippedOrders;
